import React, { FC, useMemo } from "react";
import { Text } from "@lookiero/sty-psp-ui";
import { style as productFeatureStyle } from "./ProductFeature.styles";

interface ProductFeatureProps {
  readonly label: string;
  readonly value: string;
}

const ProductFeature: FC<ProductFeatureProps> = ({ label, value }) => {
  const style = useMemo(() => productFeatureStyle(), []);

  return (
    <Text>
      <Text level={1} style={style.label}>
        {label}
      </Text>{" "}
      <Text level={1} style={style.value} variant="detail">
        {value}
      </Text>
    </Text>
  );
};

export { ProductFeature };
